// /Users/zachepilka/radiomonitor-frontend/src/pages/static/PrivacyPage.en.jsx
import React from 'react';

export default function PrivacyPageEn() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Radiomonitor.net Privacy Policy</h1>
      <p>
        This Privacy Policy describes what data Radiomonitor.net collects, how it is used, and how we protect your
        information. By using our Service, you agree to this Policy.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. What data we collect</h2>
      <p>We collect only the data necessary for the Service to operate:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>technical information (IP address, device type, browser, operating system);</li>
        <li>statistical data on listener connections to online radio stations;</li>
        <li>contact details you provide during registration (e.g., email).</li>
      </ul>
      <p>
        We do not collect sensitive personal data (e.g., passport or banking details), except where the user
        voluntarily provides them for payment or communication.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. How we use data</h2>
      <p>Data are used exclusively for:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>providing analytics and on-air monitoring services;</li>
        <li>improving the Service;</li>
        <li>technical user support;</li>
        <li>informing about updates and new Radiomonitor.net features.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Sharing data with third parties</h2>
      <p>We do not sell or transfer your data to third parties.</p>
      <p>Exceptions apply where disclosure is required by law.</p>
      <p>
        For payment processing we may use trusted third-party payment systems (they process data independently of us).
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Data retention</h2>
      <p>We retain data only as long as necessary to provide the services.</p>
      <p>Users may request deletion of their data, and we will fulfill such requests within a reasonable time.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Data security</h2>
      <p>
        Radiomonitor.net applies technical and organizational measures to protect data from unauthorized access,
        alteration, or destruction.
      </p>
      <p>
        We cannot guarantee 100% security on the Internet, but we take all reasonable steps to ensure it.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Cookies</h2>
      <p>We may use cookies to improve user experience and collect statistics.</p>
      <p>You can disable cookies in your browser, though this may affect proper functioning of the Service.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. Your rights</h2>
      <p>Users have the right to:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>obtain information about their data stored by the Service;</li>
        <li>request correction or deletion of such data;</li>
        <li>withdraw consent to data processing.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Changes to this Policy</h2>
      <p>We may periodically update this Policy. The current version is always available on the Radiomonitor.net website.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Contacts</h2>
      <p>
        For privacy matters, please contact:
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
